<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>{{ message }}</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="dialogRef.close('OK')" type="submit" color="accent">OK</button>
</div>
